"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.Card = styled_1.default.div `
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-radius: ${(0, ui_theme_1.fromTheme)('provider_profile_border_radius')};
  border: ${(0, ui_theme_1.fromTheme)('provider_profile_border_style')}
    ${(0, ui_theme_1.fromTheme)('provider_profile_color_border')}
    ${(0, ui_theme_1.fromTheme)('provider_profile_border_width')};
  box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')};
  -webkit-box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')};
  -moz-box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')};
`;
//# sourceMappingURL=card-container.styles.js.map